export default {
  data () {
    return {
      rules: {
        required: v => !!v || 'This field is required',
        requiredText: v => (v && !!v.trim().length) || 'This field is required',
        requiredMultiple: v => !!v.length || 'This field is required',
      },
    }
  },
}
